var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDork = function SvgDork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16.933 16.933"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.996.53H7.937c-.57 0-.919.358-1.043.702L2.386 13.758h12.16L10.038 1.231C9.869.764 9.439.534 8.996.53m-2.62 3.703h4.18l.953 2.646H5.424zM4.663 8.995h7.609l.952 2.646H3.71zm-3.338 5.292a.8.8 0 0 0-.795.793v.529a.8.8 0 0 0 .795.795H15.61c.435 0 .793-.36.793-.795v-.53a.797.797 0 0 0-.793-.792z"
  })));
};
export default SvgDork;